export default __webpack_public_path__ + "images/7F.6538535.png";